// Action
const OPEN = 'modal/open';
const CLOSE = 'modal/close';
const SET_CONTENTS = 'modal/setContents';
// Action Creator
export const open = () => {
    return {
        type: OPEN,
    };
};
export const close = () => {
    return {
        type: CLOSE,
    };
};
export const setContents = (contents) => {
    return {
        payload: {
            contents,
        },
        type: SET_CONTENTS,
    };
};
const initialState = {
    contents: null,
    isOpened: false,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case OPEN: {
            return Object.assign(Object.assign({}, state), { isOpened: true });
        }
        case CLOSE: {
            return Object.assign(Object.assign({}, state), { isOpened: false });
        }
        case SET_CONTENTS: {
            return Object.assign(Object.assign({}, state), { contents: action.payload.contents });
        }
        default: {
            return state;
        }
    }
};
